import { Injectable } from '@angular/core';
import * as CalUtil from '../calendar-util';

@Injectable()
export class CalendarUtils {
  getMonthView(args: CalUtil.GetMonthViewArgs): CalUtil.MonthView {
    return CalUtil.getMonthView(args);
  }

  getWeekViewHeader(args: CalUtil.GetWeekViewHeaderArgs): CalUtil.WeekDay[] {
    return CalUtil.getWeekViewHeader(args);
  }

  getWeekView(args: CalUtil.GetWeekViewArgs): CalUtil.WeekView {
    return CalUtil.getWeekView(args);
  }

  getDayView(args: CalUtil.GetDayViewArgs): CalUtil.DayView {
    return CalUtil.getDayView(args);
  }

  getDayViewHourGrid(args: CalUtil.GetDayViewHourGridArgs): CalUtil.DayViewHour[] {
    return CalUtil.getDayViewHourGrid(args);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/calendar/common/calendar-utils.provider.ts